<template>
    <el-row class="warp">
        <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
            <!--工具条-->
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
                <el-form :inline="true">
                    <el-form-item>
                        <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="clickUpload">文件上传</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="resetForm('filters')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!--列表-->
            <el-table :data="users" highlight-current-row v-loading="loading" style="width: 100%">
                <el-table-column label="序号" type="index">
                </el-table-column>
                <el-table-column prop="time" :formatter="formatTime" label="日期" min-width="100">
                </el-table-column>
                <el-table-column prop="week" label="星期">
                </el-table-column>
                <el-table-column prop="rank" label="同行层级排名" min-width="100">
                </el-table-column>
                <el-table-column prop="tradingvolume" label="成交金额">
                </el-table-column>
                <el-table-column prop="realmoney" label="真实成交金额" min-width="100"> </el-table-column>
                <el-table-column prop="returnmoney" label="不含税回款" min-width="100"> </el-table-column>
                <el-table-column prop="scalpmoney" label="刷单金额"> </el-table-column>
                <el-table-column prop="refund" label="退款金额">
                </el-table-column>
                <el-table-column prop="saleuser" label="客单价"> </el-table-column>

                <el-table-column prop="cvr" label="转化率"> </el-table-column>
                <el-table-column prop="pv" label="浏览量"> </el-table-column>
                <el-table-column prop="uv" label="访客数"> </el-table-column>
                <el-table-column prop="users" label="成交用户数" min-width="100"> </el-table-column>
                <el-table-column prop="sales" label="成交件数"> </el-table-column>
                <el-table-column prop="tgcost" label="推广费用"> </el-table-column>
                <el-table-column prop="tgpersent" label="推广费比"> </el-table-column>
                <el-table-column prop="remark" label="备注"> </el-table-column>
            </el-table>
            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                    :total="total" style="float: right">
                </el-pagination>
            </el-col>
        </el-col>
    </el-row>
</template>

<script>
import API from "../../../../api/frsaleapi/index"
import moment from 'moment';
export default {
    data() {
        return {
            loading: false,
            total: 0,
            page: 1,
            limit: 10,
            users: [],
            value1: ""
        };
    },
    methods: {
        formatTime(row, column) {
            let date = row[column.property];
            if (date === undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        clickUpload() {
            this.$router.push("/sys/frsale/tmjieyu/upload");
        },
        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.search();
        },
        handleSearch() {
            this.total = 0;
            this.page = 1;
            this.search();
        },
        search: function () {

            var da = null;
            if (this.value1 != "" && this.value1 != null) {
                da =
                    this.dateFormat(this.value1.toString().split(",")[0]) +
                    "," +
                    this.dateFormat(this.value1.toString().split(",")[1]);
            }

            let that = this;
            let params = {
                pageNum: that.page,
                pageSize: that.limit,
                value: da
            };

            that.loading = true;
            API.tmJyPage(params)
                .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.data.totalSize) {
                            that.total = result.data.totalSize;
                            that.users = result.data.content;
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                            showClose: true,
                            message: err.toString(),
                            duration: 2000,
                        });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                        showClose: true,
                        message: "请求出现异常",
                        duration: 2000,
                    });
                });
        },
        dateFormat(dateData) {
            var date = new Date(dateData);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            const time = y + "-" + m + "-" + d;
            return time;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$nextTick(() => { });
        },
    },

    mounted() {
        this.handleSearch();
    },
};
</script>

<style scoped>

</style>
